const btn = document.querySelectorAll('[data-back-to-top]')
btn.forEach(e =>{
    e.addEventListener('click', (ev) =>{
        ev.preventDefault();
        window.scrollTo(0, 0);
    })
})
